<template>
    <form
        :action="autocompleteUrl"
        v-on:submit.prevent="search"
        method="get"
        accept-charset="utf-8"
        class="c-search__form"
    >
        <div class="c-search__select">
            <label class="c-btn is-label" for="autocomplete-category-id" tabindex="-1">
                <span v-if="categoryIdValue">{{ selectedCategoryFirstLetter }}...</span>
                <i v-else class="ico ico-filter-funnel"></i>
            </label>

            <select
                id="autocomplete-category-id"
                v-model="categoryId"
                @change="onSelectChange"
                class="c-btn is-select"
            >
                <option :value="null">{{ $t("Autocomplete.Header.allCategories") }}</option>
                <option
                    :value="searchCategory.id"
                    v-for="searchCategory in searchCategories"
                    :key="searchCategory.id"
                >
                    {{ searchCategory.name }}
                </option>
            </select>
        </div>

        <button
            type="button"
            :class="{ 'is-visible': keyword && isFormVisible }"
            :tabindex="keyword ? '0' : '-1'"
            class="c-search__clear c-btn c-btn--close-ultra-light-grey desktop-is-hidden mobile-is-visible"
            @click.prevent="hideForm"
        >
            <i class="ico ico-chevron-left"></i>
        </button>

        <button
            type="button"
            :class="{ 'is-visible': keyword && isFormVisible }"
            :tabindex="keyword ? '0' : '-1'"
            class="c-search__clear c-btn c-btn--close-ultra-light-grey mobile-is-hidden desktop-is-visible"
            @click.prevent="clear()"
        >
            <i class="ico ico-close"></i>
        </button>

        <input
            type="text"
            :id="'autocomplete-' + parseInt(Math.random() * 1000)"
            :value="keyword"
            name="search"
            autocomplete="off"
            :placeholder="inputPlaceholder"
            @input="onInput"
            @focus="showForm"
            @keyup.enter="redirectToSearch"
            class="c-search__input"
            :class="{
                'is-empty': !keyword,
                'has-clear-visible': keyword && isFormVisible,
                'is-open': isOpen,
            }"
            ref="searchInput"
        />

        <div class="c-search__buttons">
            <div
                class="c-btn c-btn--transparent"
                data-toggle="modal"
                data-target="#ean-scanner"
                data-backdrop="true"
            >
                <i class="ico ico-barcode"></i>
            </div>
            <a
                :href="searchUrl"
                class="c-search__btn c-btn c-btn--red is-search"
                :class="{ 'is-loading': isLoading }"
            >
                <i class="ico ico-search"></i>
            </a>
        </div>

        <button
            type="button"
            @click.prevent="clear()"
            class="c-search__btn c-btn c-btn--close is-close"
            :class="{ 'is-loading': isLoading }"
        >
            <i aria-hidden="true" class="ico ico-close"></i>
        </button>
    </form>
</template>

<script>
import RshopAutocompleteForm from "FrontendComponents/Autocomplete/Form/index.vue";
import { getCookie, setCookie } from "Functions/cookie";

export default {
    extends: RshopAutocompleteForm,
    data() {
        return {
            searchCategories: Eshop.custom.searchCategories,
            keyword: "",
        };
    },
    mounted() {
        // This can be removed, but I let it here, for other projects or maybe if future problems (but I believe there will be not)
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("scanner") || urlParams.has("skener")) {
            setCookie("display_scanner", "1", 365);
        }
    },
    props: {
        isFormVisible: {
            type: Boolean,
            default: false,
        },
        isOpen: {
            type: Boolean,
            default: false,
        },
        inputPlaceholder: {
            type: String,
            required: true,
        },
        categoryIdValue: {
            type: [String, Number],
            default: null,
        },
    },
    methods: {
        showForm() {
            this.$emit("show-form");
        },
        hideForm() {
            this.$emit("hide-form");
        },
        hideResults() {
            this.$emit("hide-results");
        },
        clear() {
            this.keyword = "";
            this.hideResults();
            this.focusInput();

            this.$emit("reset-matches");
        },
        focusInput() {
            this.$nextTick(() => {
                this.$refs.searchInput.focus();
            });
        },
        onInput(event) {
            this.keyword = event.target.value;

            this.search();
        },
        redirectToSearch() {
            window.location.href = this.searchUrl;
        },
        onSelectChange(e) {
            this.$emit("update:categoryIdValue", e.target.value);
        },
    },
    computed: {
        hasQrScannerParam() {
            const urlParams = new URLSearchParams(window.location.search);
            const hasCookie = getCookie("display_scanner") !== "";
            return urlParams.has("scanner") || urlParams.has("skener") || hasCookie;
        },
        searchUrl() {
            let url = `/vyhladavanie`;
            let params = [];

            if (this.keyword) {
                params.push(`search=${this.keyword}`);
            }
            if (this.categoryIdValue) {
                params.push(`category_id=${this.categoryIdValue}`);
            }

            return params.length ? `${url}?${params.join("&")}` : url;
        },
        selectedCategoryFirstLetter() {
            if (this.categoryIdValue !== null && Array.isArray(this.searchCategories)) {
                const selectedCategory = this.searchCategories.find(
                    (item) => item.id === this.categoryIdValue
                );
                return selectedCategory
                    ? selectedCategory.name.trim().charAt(0).toUpperCase()
                    : null;
            }
            return null;
        },
    },
    watch: {
        isFormVisible(value) {
            if (value) {
                this.focusInput();
            }
        },
        categoryIdValue() {
            if (this.keyword) {
                this.search();
            }
        },
        // toto je skaredy ojeb, no, nechcelo sa mi uz stacat cas
        isLoading(value) {
            this.$parent.isLoading = value;
        },
    },
};
</script>
